import {DndProvider, useDrag, useDrop} from "react-dnd";
import {
  COUNTRIES_LIST_IDS,
  getCountryIcon,
  getCountryName,
  sortCountriesByName
} from "../../constants/countries";
import Ripple from "../../../../../../../../../dumb/Ripple";
import {DeleteOutlineOutlined, LibraryAddOutlined} from "@material-ui/icons";
import React from "react";
import {PAYMENT_METHODS_LIST} from "../../../../../../../../../../constants/paymentMethods";
import ArrowA from "../../../../../../../../../icons/ArrowA";
import {AdminSwitch} from "../../../../../../../../../dumb/FormInputs";
import {HTML5Backend} from "react-dnd-html5-backend";
import {FormAdditionalBtn, FormSubmitBtn, FormWrapper} from "../../../../../../../../../dumb/FormHandlers";
import {apiAdminRetailerUpdate} from "../../../../../../../../../../api/admin/retailers";

const ItemTypes = {
  BOX: 'box',
}

const DraggableCountry = ({name}) => {
  const style = {
    display: 'flex',
    alignItems: 'center',
    border: '1px dashed gray',
    backgroundColor: 'white',
    padding: '0.5rem 1rem',
    marginRight: '1.5rem',
    marginBottom: '1.5rem',
    cursor: 'move',
    float: 'left',
  }


  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.BOX,
    item: { name },
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult()
      // if (item && dropResult) {
      //   alert(`You dropped ${item.name} into ${dropResult.name}!`)
      // }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })
  const opacity = isDragging ? 0.4 : 1;

  const Icon = getCountryIcon(name);
  const countryName = getCountryName(name);

  return (
    <div
      ref={drag}
      className="wFitContent layoutRow aiC pv7 ph12 f10 b1 bsDashed bcGray crMove"
      style={{opacity}}
    >
      {!!Icon
        ? (
          <div className="mr10">
            <Icon className="dB" width="25px" />
          </div>
        ) : false
      }
      {countryName}
    </div>
  )
}

const DropZoneComponent = ({label, name, items = {}, onAddAllClick, disableAddAllBtn, onRemoveClick, onChange, DisplayComponent}) => {
  const [{ canDrop, isOver }, drop] = useDrop(() => ({
    accept: ItemTypes.BOX,
    drop: (item) => {
      onChange(name, item.name, items);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }))
  const isActive = canDrop && isOver

  return (
    <div ref={drop} className="rlv">
      <DisplayComponent
        label={label}
        itemsList={items[name]}
        isActive={isActive}
        canDrop={canDrop}
        onAddAllClick={() => onAddAllClick(name)}
        disableAddAllBtn={disableAddAllBtn}
        onRemoveClick={() => onRemoveClick(name)}
      />
    </div>
  )
}

const NeutralZone = ({itemsList = [], isActive, canDrop}) => {
  return (
    <>
      <div
        className={`
          w h200 ovAuto rlv bgF b1 bs bcDCDCDC ph15 pv10
        ` + (isActive ? ' active' : '')
          + (canDrop ? ' can-drop' : '')}
      >
        <div className="layoutRow fxwWrap mt10 mh-7 (ph7|mb10)>1">
          {itemsList.map((key, i) => (
            <div key={i}>
              <DraggableCountry name={key} />
            </div>
          ))}
        </div>
      </div>
      {isActive && (
        <div className="w h abs st0 sl0 layoutRow jcC aiC bgFAFAFA z100">
          {isActive ? 'Release to drop' : 'Drag a box here'}
        </div>
      )}
    </>
  )
}

const BottomZone = ({label, itemsList = [], onAddAllClick, disableAddAllBtn, onRemoveClick, isActive, canDrop}) => {
  return (
    <div
      className={`
        w h200 ovAuto rlv bgF b1 bs bcDCDCDC ph15 pv10
      ` + (isActive ? ' active' : '')
        + (canDrop ? ' can-drop' : '')}
    >
      <div className="layoutRow jcSB aiC">
        <div className="f10 c3E4044">{label}</div>
        <div className="layoutRow jcSB aiC">
          <Ripple className="mr10" disabled={disableAddAllBtn} onClick={onAddAllClick}>
            <LibraryAddOutlined className={`dB (o40).disabled` + (disableAddAllBtn ? ' disabled' : '')} fill="#c3E4044" />
          </Ripple>
          <Ripple onClick={onRemoveClick} disabled={!itemsList.length}>
            <DeleteOutlineOutlined className={`dB (o40).disabled` + (!itemsList.length ? ' disabled' : '')} fill="#c3E4044" />
          </Ripple>
        </div>
      </div>
      <div className="layoutRow fxwWrap mt10 mh-7 (ph7|mb10)>1">
        {itemsList.map((key, i) => (
          <div key={i}>
            <DraggableCountry name={key} />
          </div>
        ))}
      </div>
      {isActive && (
        <div className="w h abs st0 sl0 layoutRow jcC aiC bgFAFAFA z100">
          {isActive ? 'Release to drop' : 'Drag a box here'}
        </div>
      )}
    </div>
  )

}

const CountriesDnD = ({methodId, formCtx}) => {
  const data = formCtx.state.data || {};

  const countriesNeutralName = `${methodId}_countries_neutral`;
  const countriesAllowedName = `${methodId}_countries_allowed`;
  const countriesShortFlowName = `${methodId}_countries_short`;
  const countriesBlockedName = `${methodId}_countries_blocked`;

  const keys = [
    countriesNeutralName,
    countriesAllowedName,
    countriesShortFlowName,
    countriesBlockedName,
  ];

  const onChange = (name, val) => {
    const data = formCtx.state.data || {};

    const nextState = {};

    keys.forEach((key) => {
      nextState[key] = data[key]
        ? data[key].filter((name) => name !== val)
        : [];
    });

    nextState[name].push(val);
    nextState[name] = nextState[name].sort(sortCountriesByName);

    formCtx.onManualChange(nextState);
  };
  const onAddAllClick = (name) => {
    const data = formCtx.state.data || {};
    const nextState = {};

    [
      countriesAllowedName,
      countriesShortFlowName,
      countriesBlockedName
    ].forEach((key) => {
      nextState[key] = key === name
        ? [
          ...(data[key] || []),
          ...(data[countriesNeutralName] || [])
        ].sort(sortCountriesByName)
        : [...(data[key] || [])];
    });

    nextState[countriesNeutralName] = [];

    formCtx.onManualChange(nextState);
  };
  const onRemoveClick = (name) => {
    const data = formCtx.state.data || {};

    const nextState = {};

    [
      countriesAllowedName,
      countriesShortFlowName,
      countriesBlockedName
    ].forEach((key) => {
      nextState[key] = key === name ? [] : [...(data[key] || [])];
    });

    nextState[countriesNeutralName] = [...data[countriesNeutralName], ...data[name]].sort(sortCountriesByName);

    formCtx.onManualChange(nextState);
  };

  const disableAddAllBtn = !(data[countriesNeutralName] || []).length;

  return (
    <div>
      <div className="w hmin60">
        <DropZoneComponent
          label="Allowed Methods"
          name={countriesNeutralName}
          items={data}
          onChange={onChange}
          DisplayComponent={NeutralZone}
        />
      </div>
      <div className="w100%+30 layoutRow mt30 mh-15 (w1/3|ph15)>1">
        <div>
          <DropZoneComponent
            label="Short Flow Methods"
            name={countriesShortFlowName}
            items={data}
            onChange={onChange}
            onAddAllClick={onAddAllClick}
            disableAddAllBtn={disableAddAllBtn}
            onRemoveClick={onRemoveClick}
            DisplayComponent={BottomZone}
          />
        </div>
        <div>
          <DropZoneComponent
            label="Allowed Methods"
            name={countriesAllowedName}
            items={data}
            onChange={onChange}
            onAddAllClick={onAddAllClick}
            disableAddAllBtn={disableAddAllBtn}
            onRemoveClick={onRemoveClick}
            DisplayComponent={BottomZone}
          />
        </div>
        <div>
          <DropZoneComponent
            label="Blocked Methods"
            name={countriesBlockedName}
            items={data}
            onChange={onChange}
            onAddAllClick={onAddAllClick}
            disableAddAllBtn={disableAddAllBtn}
            onRemoveClick={onRemoveClick}
            DisplayComponent={BottomZone}
          />
        </div>
      </div>
    </div>
  )
}


const FormBody = ({formCtx}) => {
  const [activeItem, setActiveItem] = React.useState();

  return (
    <div>
      {PAYMENT_METHODS_LIST.map((el) => {
        const methodId = el.id;
        const isActive = activeItem === methodId;

        const isEnabled = formCtx.state.data[`${methodId}_enabled`];

        return (
          <React.Fragment key={methodId}>
            <div className="rlv">
              <Ripple
                className={`
                  h45 mt20 pl15 layoutRow jcSB aiC
                  f16 fw3 tc ttU c3E4044 bgFAFAFA b1 bs bcDCDCDC
                ` + (isActive ? ' active' : '')}
                onClick={() => {
                  setActiveItem(isActive ? '' : methodId)
                }}
              >
                <div>{el.name}</div>
                <div
                  className={
                    `layoutRow fhaC fvaC sq30 eN dn (rx180).active`
                    + (isActive ? ' active' : '')
                  }
                >
                  <ArrowA className="w14"/>
                </div>
              </Ripple>
              <div className="abs st50% sr40 xY-50%">
                <AdminSwitch
                  label={isEnabled ? 'Enabled' : 'Disabled'}
                  name={`${methodId}_enabled`}
                  formCtx={formCtx}
                />
              </div>
            </div>
            <div
              className={`
                h0 ovH (hAuto).active
              ` + (isActive ? ' active' : '')}
            >
              <div className="layoutRow aiC mt10 mb15">
                <div className="f18 fw7 lh">
                  Countries
                </div>
              </div>
              {isActive && (
                <DndProvider backend={HTML5Backend}>
                  <CountriesDnD methodId={methodId} formCtx={formCtx} />
                </DndProvider>
              )}
            </div>
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default ({data, close, onResult}) => {
  const merchantMethods = data.merchant_methods || {};

  const globalMethodsEnabled = data.global_methods;
  const merchantMethodsEnabled = merchantMethods.available_methods || [];
  const merchantCountiesAllowed = merchantMethods.countries_allowed || {};
  const merchantCountiesShortFlow = merchantMethods.countries_short || {};
  const merchantCountiesBlocked = merchantMethods.countries_blocked || {};

  const formData = {};

  PAYMENT_METHODS_LIST.forEach(({id: methodId}) => {
    const switchName = `${methodId}_enabled`;
    const countriesAllowedName = `${methodId}_countries_allowed`;
    const countriesBlockedName = `${methodId}_countries_blocked`;
    const countriesShortName = `${methodId}_countries_short`;
    const countriesNeutralName = `${methodId}_countries_neutral`;

    const notNeutralCountries = [
      ...(merchantCountiesAllowed[methodId] || []),
      ...(merchantCountiesShortFlow[methodId] || []),
      ...(merchantCountiesBlocked[methodId] || []),
    ]

    formData[switchName] = merchantMethodsEnabled.includes(methodId);
    formData[countriesAllowedName] = (merchantCountiesAllowed[methodId] || []).sort(sortCountriesByName);
    formData[countriesShortName] = (merchantCountiesShortFlow[methodId] || []).sort(sortCountriesByName);
    formData[countriesBlockedName] = (merchantCountiesBlocked[methodId] || []).sort(sortCountriesByName);
    formData[countriesNeutralName] = COUNTRIES_LIST_IDS.filter((id) => {
      return !notNeutralCountries.includes(id)
    }).sort(sortCountriesByName);
  })

  return (
    <FormWrapper
      data={formData}
      onSubmit={(submitData) => {
        let allowed = [];
        let blocked = [];
        const countries_allowed = {};
        const countries_blocked = {};
        const short_flow = {};

        PAYMENT_METHODS_LIST.forEach((el) => {
          const methodId = el.id;
          const switchName = `${methodId}_enabled`;
          const countriesAllowedName = `${methodId}_countries_allowed`;
          const countriesShortName = `${methodId}_countries_short`;
          const countriesBlockedName = `${methodId}_countries_blocked`;

          const isEnabled = !!submitData[switchName]

          if (isEnabled) {
            allowed.push(methodId);
          } else {
            blocked.push(methodId);
          }

          if ((submitData[countriesAllowedName] || []).length) countries_allowed[methodId] = submitData[countriesAllowedName];
          if ((submitData[countriesShortName] || []).length) short_flow[methodId] = submitData[countriesShortName];
          if ((submitData[countriesBlockedName] || []).length) countries_blocked[methodId] = submitData[countriesBlockedName];
        });

        allowed = allowed.filter((method) => !globalMethodsEnabled.includes(method));
        blocked = blocked.filter((method) => globalMethodsEnabled.includes(method));

        const methods = {};

        if (allowed.length) methods['allowed'] = allowed;
        if (blocked.length) methods['blocked'] = blocked;

        if (Object.keys(countries_allowed).length) methods['countries_allowed'] = countries_allowed;
        if (Object.keys(short_flow).length) methods['short_flow'] = short_flow;
        if (Object.keys(countries_blocked).length) methods['countries_blocked'] = countries_blocked;

        const merchant = {
          ...(data.merchant || {}),
          methods
        };

        return apiAdminRetailerUpdate({
          id: data.id,
          login: data.login,
          name: data.name,
          merchant
        });
      }}

      onResult={onResult}
    >
      {(formCtx) => (
        <>
          <FormBody formCtx={formCtx} />
          <div className="layoutRow fxwWrap mt10 mh-15 (mt10|ph15)>1">
            <div>
              <FormSubmitBtn formCtx={formCtx}>
                Submit
              </FormSubmitBtn>
            </div>
            <div>
              <FormAdditionalBtn
                onClick={() => {
                  formCtx.enableLoadingState();
                  return apiAdminRetailerUpdate({
                    id: data.id,
                    login: data.login,
                    name: data.name,
                    merchant: {
                      ...(data.merchant || {}),
                      methods: {}
                    }
                  }).then(onResult)
                    .catch(formCtx.disableLoadingState)
                }}
                disabled={merchantMethods.isGlobal}
                formCtx={formCtx}
              >
                Back to Global Settings
              </FormAdditionalBtn>
            </div>
            <div>
              <FormAdditionalBtn
                onClick={close}
                formCtx={formCtx}
              >
                Cancel
              </FormAdditionalBtn>
            </div>
          </div>
        </>
      )}
    </FormWrapper>
  )
}
